import React from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { ANALYTICS_TAGS } from '../../../common/constants';
import { useStep } from '../../../controllers/edit-store/helpers';
import { EditStep } from '../../../controllers/edit-store/state/types';

import { Header } from './header';
import { Schedule } from './schedule';
import { Sidebar } from './sidebar';
import { Container, Content } from './styled';

const EditSchedule = () => {
	const [step] = useStep();

	return (
		<AnalyticsContext
			data={{
				source: step === EditStep.List ? 'editMode' : 'editRotation',
				tags: step === EditStep.List ? ANALYTICS_TAGS.editMode : ANALYTICS_TAGS.editRotation,
			}}
		>
			<Container flexDirection="column">
				<Header />
				<Content>
					<Sidebar />
					<Schedule />
				</Content>
			</Container>
		</AnalyticsContext>
	);
};

export { EditSchedule };
